import { render, staticRenderFns } from "./AffiliatePortalShell.vue?vue&type=template&id=68c42cfe&scoped=true"
import script from "./AffiliatePortalShell.vue?vue&type=script&lang=js"
export * from "./AffiliatePortalShell.vue?vue&type=script&lang=js"
import style0 from "./AffiliatePortalShell.vue?vue&type=style&index=0&id=68c42cfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c42cfe",
  null
  
)

export default component.exports